import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-504d5710"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "no-redirect"
}

import { ref,watch,computed } from 'vue'
import  { useRoute  } from 'vue-router'
import * as pathToRegexp from 'path-to-regexp'
import { useStore } from 'vuex';
import { getIframePath } from '@/utils/cookies'
import { base64 } from '@/utils/base';

 
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let levelList = ref(null);
 let route: any = useRoute();
 const store = useStore();
  const language = computed(() => {
    return store.getters.language
  })


const iframe_path = computed(() => {
  let title = decodeURIComponent(route.query.tcn)
  let title_en = decodeURIComponent(route.query.ten)
  // return store.getters.iframe_path || JSON.parse(getIframePath())
  let meta = {
    title: title,
    title_en: title_en
  }
  return meta
})
let getBreadcrumb = ()=>{

    let matched:any = route.matched.filter(item => {
        if(route.path==='/iframe' && iframe_path){   
           item.meta = iframe_path.value ? iframe_path : item.meta
        }
        if (item.name) {
          return true
        }
      })
    const first:any = matched[0]

    if (first && first.name.trim().toLocaleLowerCase() !== 'Home Page'.toLocaleLowerCase()) {
        matched = [].concat(matched)
      }
    levelList.value = matched
    console.log('matched', levelList.value);
      console.log('matchedroute', route);
}
getBreadcrumb()

watch(()=>route.path,()=>{
   getBreadcrumb()
})
let pathCompile = (path)=> {
    const { params } = route   
     var toPath = pathToRegexp.compile(path) 
      return toPath(params)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_breadcrumb, {
      separator: "/",
      class: "app-breadcrumb"
    }, {
      default: _withCtx(() => [
        _createVNode(_TransitionGroup, { name: "breadcrumb" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(levelList), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
                key: item.path
              }, {
                default: _withCtx(() => [
                  (item.redirect==='noredirect'||index==_unref(levelList).length-1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(language) === 'en' ? item.meta.title_en : item.meta.title), 1))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: item.redirect||_unref(pathCompile)(item.path)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(language) === 'en' ? item.meta.title_en : item.meta.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})